import React from "react";
import "./product.css";
import { trackProjectClick } from "../../utils/analytics";

const Product = ({ project, isEnterprise }) => {
  const { title, company, role, category, desc, highlights, tech, link } = project;

  return (
    <div className="project-card glass-panel">
      {/* Decorative Card Header */}
      <div className="project-card-header">
        <span className="project-category">{category}</span>
        {isEnterprise && <span className="enterprise-badge">Enterprise</span>}
      </div>

      <div className="project-info">
        <h3 className="project-title">{title}</h3>
        {company && <span className="project-meta">{role} @ {company}</span>}
        <p className="project-desc">{desc}</p>

        {/* Bullet point accomplishments */}
        {highlights && highlights.length > 0 && (
          <ul className="project-highlights">
            {highlights.map((highlight, idx) => (
              <li key={idx}>
                <i className="fa-solid fa-circle-check"></i>
                <span>{highlight}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Tech pills section */}
      <div className="project-tech-section">
        <div className="project-tech-list">
          {tech.map((t, idx) => (
            <span key={idx} className="project-tech-pill">
              {t}
            </span>
          ))}
        </div>
      </div>

      {/* Card CTA/Footer */}
      {!isEnterprise && link && link !== "#" && (
        <div className="project-action">
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            className="project-link"
            onClick={() => trackProjectClick(title, link, category)}
          >
            Visit Project <i className="fa-solid fa-arrow-up-right-from-square"></i>
          </a>
        </div>
      )}
    </div>
  );
};

export default Product;
